const localeDemo_US = {
  text: 'Life is more than temporary and, and poetry and distance',
};

export default localeDemo_US;